export default __webpack_public_path__ + "static/media/10.2.03428cd4.jpg";